import { IconCheck, IconX, IconExclamationMark, IconDatabase, IconPoint, IconCode, IconDevices2, IconExchange } from '@tabler/icons-react';

export const brand = {
    initial: 'lms-mantine-202308-iwannaeatdoughnut',
    shortName: 'Lumos',
    longName: 'Lumos',
    appName: 'Lumos App',
    web: 'Lumos.id',
    instagram: 'Lumos_Solution',
    email: 'Admin@Lumos.id',
    tag: {
        one: 'Lorem Ipsum',
        two: 'Lorem Ipsum',
    },
    rules: {
        one: 'Pengambilan barang dapat dilakukan bila sudah menyelesaikan pembayaran.',
        two: 'Garansi perbaikan 1 bulan untuk kerusakan dengan penyebab yang sama. Bon jangan hilang untuk garansi sparepart.',
        three: 'Garansi hardware yang diganti, berlaku sejak barang diinfokan sudah selesai (bukan dari saat pengambilan)',
        // four: 'Bon jangan hilang untuk garansi sparepart.',
        five: 'Pembayaran dapat dilakukan tunai/transfer BCA 8100877989 a.n. Hans Adrian Susanto.',
        six: 'Bila barang tidak diambil lebih dari 1 bulan sejak diinfokan selesai, maka segala kehilangan dan kerusakan adalah diluar tanggung jawab kami.',
    }
}

export const pusatAddress = 'Jl. Kembar Tengah 2 No 12, Bandung';
export const cabang1Address = 'Universitas Maranatha, Gedung GWM Lt.1 depan foodcourt Eureka';

/*
rules: {
        one: 'Pengambilan barang dapat dilakukan bila sudah menyelesaikan pembayaran.',
        two: 'Garansi item 1 bulan untuk kerusakan yang sama. Bon jangan hilang untuk garansi sparepart.',
        three: 'Garansi hardware yang diganti, berlaku sejak barang diinfokan sudah selesai (bukan dari saat pengambilan)',
        four: 'Bon jangan hilang untuk garansi sparepart.',
        five: 'Pembayaran dapat dilakukan tunai/transfer BCA 8100877989 a.n. Hans Adrian Susanto.',
        six: 'Bila barang tidak diambil lebih dari 1 bulan sejak diinfokan selesai, maka segala kehilangan dan kerusakan adalah diluar tanggung jawab kami.',
    }
*/

export const pusatCabang = {
    pusat: {
        flag: 'pusat',
        flagCaption: 'Pusat',
        shortName: 'Kembar Tengah',
        noHp: {
            one: '0895618753345'
        },
        address: pusatAddress,
        web: brand.web,
        instagram: brand.instagram,
        email: brand.email,
        tag: {
            one: brand.tag.one,
            two: brand.tag.two,
        },
        rules: {
            one: brand.rules.one,
            two: brand.rules.two,
            three: brand.rules.three,
            // four: brand.rules.four,
            five: 'Pembayaran dapat dilakukan tunai/transfer BCA 8100877989 a.n. Hans Adrian Susanto.',
            six: brand.rules.six
        }
    },
    cabang1: {
        flag: 'cabang1',
        flagCaption: 'Cabang',
        shortName: 'Maranatha',
        noHp: {
            one: '089507772711'
        },
        address: cabang1Address,
        web: brand.web,
        instagram: brand.instagram,
        email: brand.email,
        tag: {
            one: brand.tag.one,
            two: brand.tag.two,
        },
        rules: {
            one: brand.rules.one,
            two: brand.rules.two,
            three: brand.rules.three,
            // four: brand.rules.four,
            five: 'Pembayaran dapat dilakukan tunai/transfer BCA 2820857758 a.n. Yurike Yuliana/Hans A.S.',
            six: brand.rules.six
        }
    }
}

export const pusatCabangActive = pusatCabang.cabang1;
export const appVersion = '260101.01';

const DOMAIN = 'veccaniclient.com';
const PORT = ''; /* kosongkan jika tidak menggunakan port */
const SUB_DOMAIN = 'php001'; /* kosongkan jika bukan sub domain */
const BACK_END = 'api';

// const DOMAIN = process.env.REACT_APP_HOST;
// const PORT = process.env.REACT_APP_PORT; /* kosongkan jika tidak menggunakan port */
// const SUB_DOMAIN = ''; /* kosongkan jika bukan sub domain */
// const BACK_END = 'lumos_mantine'; /* lumos_migrasi */

export const DOMAIN_NAME = 'https://' + DOMAIN;
export const DOMAIN_NAME_HOST = DOMAIN_NAME + (PORT ? (':' + PORT) : '');

// export const ROOT_BASE_URL = DOMAIN_NAME + (SUB_DOMAIN ? ('/' + SUB_DOMAIN) : '') + '/' + BACK_END;
export const ROOT_BASE_URL = 'https://' + (SUB_DOMAIN ? (SUB_DOMAIN + '.') : '') + DOMAIN;

export const DOMAIN_FE = SUB_DOMAIN ? (SUB_DOMAIN + '.' + DOMAIN) : DOMAIN_NAME_HOST;

// https://veccaniclient.com/php001
// https://www.php001.veccaniclient.com/assets/
// https://www.php001.veccaniclient.com/apione/test12345

// ! jangan menggunakan slash di akhir URL !
export const BE_API_SU_ONE = ROOT_BASE_URL + '/apisuone';
export const BE_API_AUTH = ROOT_BASE_URL + '/apiauth';
export const BE_API_ONE = ROOT_BASE_URL + '/apione';
export const BE_API_TWO = ROOT_BASE_URL + '/apitwo';
export const BE_API_THREE = ROOT_BASE_URL + '/apithree';

export const BE_API_DISTRIBUTOR = ROOT_BASE_URL + '/apidistributor';
export const BE_API_TOKO = ROOT_BASE_URL + '/apitoko';
export const BE_API_ONLINE = ROOT_BASE_URL + '/apionline';
export const BE_API_LAPORAN = ROOT_BASE_URL + '/apilaporan';
export const BE_API_DOCUMENT = ROOT_BASE_URL + '/apidocument';
export const BE_API_DOCUMENT_API = ROOT_BASE_URL + '/apidocumentapi';
export const BE_API_DELETE = ROOT_BASE_URL + '/apidelete';
// ! jangan menggunakan slash di akhir URL !

const SetIcon = ({ StateIcon, stateColor = 'gray' }) => {
    return <StateIcon
        size="1rem"
        stroke={1}
        style={{
            color: stateColor
        }}
    />;
}

export const role = {
    super_user: {
        caption: 'Super User',
        slugLevel: 'super_user',
        localStorageIdleTimeName: '356b50040c7346c6a0454a4589f66586_su',
        subLevel: {
            super_user: {
                caption: 'Super User',
                slugSubLevel: 'super_user',
                slugLink: 'su',
            }
        }
    },
    owner: {
        caption: 'Owner',
        slugLevel: 'owner',
        localStorageIdleTimeName: '45b08c7f046544ca9f94df8af8cfc0ae_ow',
        subLevel: {
            owner: {
                caption: 'Owner',
                slugSubLevel: 'owner',
                slugLink: 'ow',
            }
        }
    },
    admin: {
        slugLevel: 'admin',
        caption: 'Admin',
        localStorageIdleTimeName: 'f3e9e1fd31554b1cbe311b2b0af09e58_ad',
        subLevel: {
            // admin_kepala: {
            //     caption: 'Kepala Admin',
            //     slugSubLevel: 'admin_kepala',
            //     slugLink: 'ak',
            // },
            admin_staf: {
                caption: 'Staf Admin',
                slugSubLevel: 'admin_staf',
                slugLink: 'as',
            }
        }
    },
    teknisi: {
        slugLevel: 'teknisi',
        caption: 'Teknisi',
        localStorageIdleTimeName: '5d4fea41470d4ac4b7e1586b7ba6ba98_tk',
        subLevel: {
            teknisi_kepala: {
                caption: 'Kepala Teknisi',
                slugSubLevel: 'teknisi_kepala',
                slugLink: 'tk',
            },
            teknisi_staf: {
                caption: 'Staf Teknisi',
                slugSubLevel: 'teknisi_staf',
                slugLink: 'ts',
            }
        }
    },
    delivery: {
        slugLevel: 'delivery',
        caption: 'Delivery',
        localStorageIdleTimeName: 'b2ec102b16a14a89b1bc842f7e76a32c_dv',
        subLevel: {
            delivery_kepala: {
                caption: 'Kepala Delivery',
                slugSubLevel: 'delivery_kepala',
                slugLink: 'dk',
            },
            delivery_staf: {
                caption: 'Staf Delivery',
                slugSubLevel: 'delivery_staf',
                slugLink: 'ds',
            }
        }
    },
}

const imageTypesAllowed = ["image/png", "image/jpg", "image/jpeg"];

export const utils = {
    showMqt: false,
    dataLimit: 25, /* 50 */
    reminderMaintenance: {
        waktu: 6 /*bulan*/
    },
    shrinkWhenScrollYAt: 20,
    flagAll: `all-${brand.initial}`,
    useIdleTimer: false,

    linkVerifikasiSlug: 'verification-link',
    linkVerifikasiSlugSU: 'verification-link-super-user',

    minCharUsername: 3,
    minCharPassword: 3,
    maxCharUsername: 12,
    maxCharPassword: 12,
    generateUsernameLength: 6,
    generatePasswordLength: 6,
    projectRating: 5,

    imageTypesAllowed: imageTypesAllowed,
    imageTypesAllowedExt: imageTypesAllowed.map(key => key.split('/')[1]),
    imageMaxSizeUploadFotoInMB: 50,
    oneBytesIs: 1048576,

    discountDeductedFrom: {
        total: { value: 'total', label: 'Total' },
        jasa: { value: 'jasa', label: 'Jasa' },
        // item: { value: 'item', label: 'Item' },
    },

    discountType: {
        percent: { value: 'percent', label: 'Persentase' },
        rupiah: { value: 'rupiah', label: 'Rupiah' },
    },

    discountFlag: {
        voucher: { value: 'voucher', label: 'Voucher' },
        discount: { value: 'discount', label: 'Discount' },
    },

    theme: {
        dark: {
            slug: 'dark',
            caption: 'Gelap',
            captionReverse: 'Terang',
            ambience: '#C14346',
        },
        light: {
            slug: 'light',
            caption: 'Terang',
            captionReverse: 'Gelap',
            ambience: '#C72438',
        },
    },
    fluid: {
        true: {
            slug: 'true',
            caption: 'Lebar',
            captionReverse: 'Fokus',
        },
        false: {
            slug: 'false',
            caption: 'Fokus',
            captionReverse: 'Lebar',
        },
        default: false,
    },
    displayMode: {
        card: {
            slug: 'card',
            caption: 'Card'
        },
        table: {
            slug: 'table',
            caption: 'Table'
        },
    },
    localStorageName: {
        theme: `theme-app-${brand.initial}`,
        fluid: `fluid-app-${brand.initial}`,
        login: `login-app-${brand.initial}`,
        loginSU: `login-su-app-${brand.initial}`,
        displayMode: `display-mode-app-${brand.initial}`,
        navBarState: `navbar-state-app-${brand.initial}`,
    },
    className: {},
    notification: {
        success: {
            caption: 'Success',
            color: 'green',
            icon: <IconCheck />
        },
        warning: {
            caption: 'Warning',
            color: 'orange',
            icon: <IconExclamationMark />
        },
        error: {
            caption: 'Error',
            color: 'red',
            icon: <IconX />
        }
    },
    modalResponse: {
        success: 'success',
        warning: 'warning',
        danger: 'danger'
    },

    sortType: {
        string: {
            slug: 'string'
        },
        integer: {
            slug: 'integer'
        },
        float: {
            slug: 'float'
        },
        date: {
            slug: 'date'
        },
    },
    priority: {
        3: {
            value: 3,
            caption: 'Low',
            colorBgLight: '#228BE6',
            colorBgDark: '#1971C2',
        },
        2: {
            value: 2,
            caption: 'Medium',
            colorBgLight: '#FF922B',
            colorBgDark: '#FD7E14',
        },
        1: {
            value: 1,
            caption: 'High',
            colorBgLight: '#F03E3E',
            colorBgDark: '#E03131',
        },
    },
    masaGaransi: {
        life_time: {
            value: 'life_time',
            caption: 'Life Time',
        },
        berjangka: {
            value: 'berjangka',
            caption: 'Berjangka',
        },
        tidak_ada: {
            value: 'tidak_ada',
            caption: 'Tidak Ada',
        },
    },
    garansiReference: {
        project_pengerjaan: {
            value: 'project_pengerjaan',
            caption: 'Proses Pengerjaan'
        },
        project_pengerjaan_history: {
            value: 'project_pengerjaan_history',
            caption: 'History Project Customer'
        },
        project_tambahan_stock: {
            value: 'project_tambahan_stock',
            caption: 'Tambahan Stok'
        },
        master_stock: {
            value: 'master_stock',
            caption: 'Master Stok'
        },
    },
    statusItemGaransi: {
        pengajuan_klaim_garansi: {
            value: 'pengajuan_klaim_garansi',
            caption: 'Pengajuan Klaim Garansi',
            description: '',
            colorBg: 'blue',
        },
        sudah_dikirim_ke_supplier: {
            value: 'sudah_dikirim_ke_supplier',
            caption: 'Sudah Dikirim Ke Supplier',
            description: '',
            colorBg: 'blue',
        },
        masuk_stock: {
            value: 'masuk_stock',
            caption: 'Masukkan Ke Stock Item',
            description: 'item diatas telah diterima dari supplier dan akan ditambahkan ke dalam sistem stok.',
            colorBg: 'blue',
        },
        kembali_uang: {
            value: 'kembali_uang',
            caption: 'Item Dikembalikan Berupa Uang',
            description: 'item diatas dikembalikan berupa uang oleh supplier. Item ini tidak akan ditambahkan ke dalam sistem stok.',
            colorBg: 'green',
        },
        item_tidak_akan_kembali: {
            value: 'item_tidak_akan_kembali',
            caption: 'Item Tidak Kembali',
            description: 'item diatas tidak dikembalikan oleh supplier. Item ini tidak akan ditambahkan ke dalam sistem stok.',
            colorBg: 'red',
        },
    },
    statusItemGaransiFoto: {
        sebelum_dikirim_supplier: {
            value: 'sebelum_dikirim_supplier',
        },
        setelah_dikirim_supplier: {
            value: 'setelah_dikirim_supplier',
        },
    },
    gender: {
        1: {
            value: 1,
            caption: 'Pria',
        },
        0: {
            value: 0,
            caption: 'Wanita',
        },
        2: {
            value: 2,
            caption: 'Ungendered',
        },
    },
    mediaQCTime: {
        sebelum: {
            value: 'sebelum',
            caption: 'Sebelum',
        },
        sesudah: {
            value: 'sesudah',
            caption: 'Sesudah',
        },
    },
    mediaQCType: {
        image: {
            value: 'image',
            caption: 'Image',
        },
        video: {
            value: 'video',
            caption: 'Video',
        },
    },
    stockItemStatus: {
        new: {
            value: 'new',
            caption: 'Baru',
            color: 'green',
            colorBgLight: '',
            colorBgDark: '',
        },
        claimed: {
            value: 'claimed',
            caption: 'Claimed',
            color: 'orange',
            colorBgLight: '',
            colorBgDark: '',
        },
        tagged: {
            value: 'tagged',
            caption: 'Tagged',
            color: 'red',
            colorBgLight: '',
            colorBgDark: '',
        }
    },
    projectProcess: {
        nota: {
            value: 'nota',
            caption: 'Nota',
        },
        antrian: {
            value: 'antrian',
            caption: 'Antrian',
        },
        pengerjaan: {
            value: 'pengerjaan',
            caption: 'Pengerjaan',
        },
        qc: {
            value: 'qc',
            caption: 'Q.C.',
        },
        selesai: {
            value: 'selesai',
            caption: 'Selesai',
        },
        sudah_diambil: {
            value: 'sudah_diambil',
            caption: 'Sudah Diambil',
        },
        dibatalkan: {
            value: 'dibatalkan',
            caption: 'Dibatalkan',
        },
    },
    penjemputanSteps: {
        nota: {
            value: 'nota',
            caption: 'Nota'
        },
        segera_menjemput: {
            value: 'segera_menjemput',
            caption: 'Segera Menjemput'
        },
        sedang_menjemput: {
            value: 'sedang_menjemput',
            caption: 'Sedang Menjemput'
        },
        sudah_input_data: {
            value: 'sudah_input_data',
            caption: 'Sudah Input Data'
        },
        sudah_serah_terima: {
            value: 'sudah_serah_terima',
            caption: 'Sudah Serah Terima'
        },
        penjemputan_dibatalkan: {
            value: 'penjemputan_dibatalkan',
            caption: 'Penjemputan Dibatalkan'
        },
    },
    alamatSelector: {
        default: {
            value: 'default'
        },
        other: {
            value: 'other'
        },
    },
    tabSelectorHistoryInputBarangName: {
        history: {
            value: 'history',
            caption: 'History Barang'
        },
        input: {
            value: 'input',
            caption: 'Input Nama Barang'
        }
    },
    jenisDokumen: {
        invoice: {
            value: 'invoice'
        },
        buktiBayar: {
            value: 'bukti_bayar'
        },
    },
    metodeBayar: {
        cash: {
            value: 'cash',
            caption: 'Cash',
        },
        transfer: {
            value: 'transfer',
            caption: 'Transfer',
        },
        cash_transfer: {
            value: 'cash_transfer',
            caption: 'Cash dan Transfer',
        },
        qris: {
            value: 'qris',
            caption: 'QRIS',
        },
        debit: {
            value: 'debit',
            caption: 'Debit',
        },
    },
    pengerjaanProgress: {
        mulai_dikerjakan: {
            value: 'mulai_dikerjakan',
            caption: 'Project Mulai Dikerjakan'
        },
        pengerjaan: {
            value: 'pengerjaan',
            caption: 'Progres Pengerjaan'
        },
        disubmit: {
            value: 'disubmit',
            caption: 'Project Disubmit'
        },
        itemCancelled: {
            value: 'item_cancelled',
            caption: 'Item Dibatalkan'
        },
        qc_approved: {
            value: 'qc_approved',
            caption: 'QC Disetujui'
        },
        qc_rejected: {
            value: 'qc_rejected',
            caption: 'QC Ditolak'
        },
        selesai_rejected: {
            value: 'selesai_rejected',
            caption: 'Proses Selesai Ditolak'
        },
        sudah_diserahkan: {
            value: 'sudah_diserahkan',
            caption: 'Barang Sudah Diserahkan'
        }
    },
    batalPemakaianItem: {
        salah_pilih: {
            slug: 'salah_pilih',
            caption: 'Salah memilih part',
            description: 'Item yang dibatalkan karena salah pilih, akan dikembalikan ke stok item.'
        },
        rusak_tidak_ada_garansi: {
            slug: 'rusak_tidak_ada_garansi',
            caption: 'Part ini rusak (Masukkan ke daftar barang rusak)',
            description: 'Item yang dibatalkan karena rusak dan tidak ada garansi, akan dimasukkan ke daftar barang rusak.'
        },
        rusak_ada_garansi: {
            slug: 'rusak_ada_garansi',
            caption: 'Part ini rusak dan lakukan klaim garansi',
            description: 'Item yang dibatalkan karena rusak dan ada garansi, akan dimasukkan ke daftar barang garansi untuk dilakukan klaim garansi.'
        },
    },
    projectType: {
        maintenance: {
            value: 'maintenance',
            caption: 'Maintenance'
        },
        service: {
            value: 'service',
            caption: 'Service'
        },
    }
}

export const menuList = {
    pengaturanAkun: {
        menuCaptionShort: 'Pengaturan Akun',
        menuCaptionLong: 'Pengaturan Akun',
        slug: 'pengaturan-akun',
        menuIcon: <SetIcon StateIcon={IconPoint} />,
        isShow: false
    },
    users: {
        menuCaptionShort: 'Kelola User',
        menuCaptionLong: 'Kelola User',
        slug: 'kelola-user',
        menuIcon: <SetIcon StateIcon={IconPoint} />,
        isShow: true
    },
    emailAplikasi: {
        menuCaptionShort: 'Kelola Email Aplikasi',
        menuCaptionLong: 'Kelola Email Aplikasi',
        slug: 'kelola-email-aplikasi',
        menuIcon: <SetIcon StateIcon={IconPoint} />,
        isShow: true
    },
    proses: {
        menuCaptionShort: 'Proses',
        menuCaptionLong: 'Proses',
        slug: 'proses',
        menuIcon: <SetIcon StateIcon={IconDevices2} />,
        isShow: true
    },
    home: {
        menuCaptionShort: 'Home',
        menuCaptionLong: 'Home',
        slug: 'home',
        menuIcon: <SetIcon StateIcon={IconDevices2} stateColor='green' />,
        isShow: true
    },
    project: {
        menuCaptionShort: 'Project',
        menuCaptionLong: 'Project',
        slug: 'project',
        menuIcon: <SetIcon StateIcon={IconDevices2} stateColor='green' />,
        isShow: true
    },
    master: {
        menuCaptionShort: 'Master Data',
        menuCaptionLong: 'Master Data',
        slug: 'master',
        menuIcon: <SetIcon StateIcon={IconDatabase} stateColor='#1c73c5' />,
        isShow: true
    },
    account: {
        menuCaptionShort: 'Account',
        menuCaptionLong: 'Account',
        slug: 'account',
        menuIcon: <SetIcon StateIcon={IconDatabase} stateColor='#1c73c5' />,
        isShow: false
    },
    stockAdjustment: {
        menuCaptionShort: 'Penyesuaian Stok',
        menuCaptionLong: 'Penyesuaian Stok',
        slug: 'stock-adjustment',
        menuIcon: <SetIcon StateIcon={IconExchange} stateColor='#1c73c5' />,
        isShow: false
    },
    dev: {
        menuCaptionShort: 'Dev',
        menuCaptionLong: 'Development',
        slug: 'dev',
        menuIcon: <SetIcon StateIcon={IconCode} stateColor='red' />,
        isShow: false
    },
    manage: {
        menuCaptionShort: 'Manage Data',
        menuCaptionLong: 'Manage Data',
        slug: 'manage',
        menuIcon: <SetIcon StateIcon={IconDatabase} stateColor='#1c73c5' />,
        isShow: true
    },
    laporan: {
        menuCaptionShort: 'Laporan',
        menuCaptionLong: 'Laporan',
        slug: 'laporan',
        menuIcon: <SetIcon StateIcon={IconPoint} />,
        isShow: true
    },
}

export const subMenuProject = `${menuList.project.slug}-project`;

export const tabProject = {
    nota: `${menuList.project.slug}-tab-nota`,
    antrian: `${menuList.project.slug}-tab-antrian`,
    pengerjaan: `${menuList.project.slug}-tab-pengerjaan`,
    qc: `${menuList.project.slug}-tab-qc`,
    selesai: `${menuList.project.slug}-tab-selesai`,
    sudahDiambil: `${menuList.project.slug}-tab-sudah-diambil`,
    dibatalkan: `${menuList.project.slug}-tab-dibatalkan`,
}

export const tabHomePengecekanIndex = `${menuList.project.slug}-tab-cek-deadline-pengecekan`;

export const menuStepProjectNota = {
    menu: menuList.project.slug,
    subMenu: subMenuProject,
    tab: tabProject.nota,
}

export const menuListSU = {
    subMenu: {
        one: {
            flag: `${menuList.manage.slug}-data-user`,
            name: 'Data User',
            icon: <SetIcon StateIcon={IconPoint} />,
            menu: menuList.manage.slug,
            tabs: {
                one: {
                    flag: `${menuList.manage.slug}-tab-data-user`,
                    name: 'Data User',
                },
                two: {
                    flag: `${menuList.manage.slug}-tab-superuser-utilities`,
                    name: 'Super User Utilitas',
                },
                three: {
                    flag: `${menuList.manage.slug}-tab-application-utilities`,
                    name: 'Aplikasi Utilitas',
                },
            }
        },
    }
}

export const menuListOW = {
    master: {
        ...menuList.master,
        ...{
            subMenu: {
                two: {
                    flag: `${menuList.master.slug}-customer`,
                    name: 'Customer',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {}
                },
                customerGroup: {
                    flag: `${menuList.master.slug}-customer-group`,
                    name: 'Customer Group',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {}
                },
                brgKtgr: {
                    flag: `${menuList.master.slug}-barang-kategori`,
                    name: 'Kategori Barang',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {}
                },
                formCekBrg: {
                    flag: `${menuList.master.slug}-form-cek-barang`,
                    name: 'Form Cek Barang',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {}
                },
                stock: {
                    flag: `${menuList.master.slug}-stock`,
                    name: 'Stok Item',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {
                        one: {
                            flag: `${menuList.master.slug}-tab-stock-item`,
                            name: 'Stok Item',
                        },
                        two: {
                            flag: `${menuList.master.slug}-tab-stock-category`,
                            name: 'Stok Kategori',
                        },
                        three: {
                            flag: `${menuList.master.slug}-tab-stock-category-sub`,
                            name: 'Stok Sub Kategori',
                        },
                        four: {
                            flag: `${menuList.master.slug}-tab-stock-damaged`,
                            name: 'Stok Rusak',
                        },
                    }
                },
                supplier: {
                    flag: `${menuList.master.slug}-supplier`,
                    name: 'Supplier',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {}
                },
                discount: {
                    flag: `${menuList.master.slug}-discount`,
                    name: 'Discount Voucher',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {
                        one: {
                            flag: `${menuList.master.slug}-tab-discount-voucher`,
                            name: 'Diskon Voucher',
                        },
                        two: {
                            flag: `${menuList.master.slug}-tab-discount-khusus`,
                            name: 'Diskon Khusus',
                        },
                        three: {
                            flag: `${menuList.master.slug}-tab-discount-review`,
                            name: 'Review Penggunaan Diskon',
                        },
                    }
                },
            }
        }
    },
    project: {
        ...menuList.project,
        ...{
            subMenu: {
                zero: {
                    flag: `${menuList.project.slug}-home`,
                    name: 'Home',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {
                        one: {
                            flag: tabHomePengecekanIndex,
                            name: 'Pengecekan',
                        },
                        two: {
                            flag: `${menuList.project.slug}-tab-bobot-kerja-teknisi`,
                            name: 'Bobot Kerja Teknisi',
                        },
                        three: {
                            flag: `${menuList.project.slug}-tab-reminder-maintenance`,
                            name: 'Reminder Maintenance',
                        },
                        four: {
                            flag: `${menuList.project.slug}-tab-sorting`,
                            name: 'Sorting Priority',
                        },
                    }
                },
                one: {
                    flag: subMenuProject, /* utils ini harus sama penamaannya utk setiap user karena ada modul (direct delivery penjemputan pemuatan nota ke step project nota pakai utils ini) */
                    name: 'Proses',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {
                        one: {
                            flag: tabProject.nota,
                            name: 'Nota',
                        },
                        two: {
                            flag: tabProject.antrian,
                            name: 'Antrian',
                        },
                        three: {
                            flag: tabProject.pengerjaan,
                            name: 'Pengerjaan',
                        },
                        four: {
                            flag: tabProject.qc,
                            name: 'QC',
                        },
                        five: {
                            flag: tabProject.selesai,
                            name: 'Selesai',
                        },
                        six: {
                            flag: tabProject.sudahDiambil,
                            name: 'Sudah Diambil',
                        },
                        seven: {
                            flag: tabProject.dibatalkan,
                            name: 'Dibatalkan',
                        }
                    }
                },
                two: {
                    flag: `${menuList.project.slug}-garansi`,
                    name: 'Klaim Garansi',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {
                        one: {
                            flag: `${menuList.project.slug}-tab-pengajuan-garansi`,
                            name: utils.statusItemGaransi.pengajuan_klaim_garansi.caption,
                        },
                        two: {
                            flag: `${menuList.project.slug}-tab-kirim-supplier-garansi`,
                            name: utils.statusItemGaransi.sudah_dikirim_ke_supplier.caption,
                        },
                        three: {
                            flag: `${menuList.project.slug}-tab-history-garansi`,
                            name: 'History Klaim Garansi',
                        },
                    }
                },
                serialNumberChecker: {
                    flag: `${menuList.project.slug}-cek-serial-number`,
                    name: 'Cek Serial Number',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {}
                },
                three: {
                    flag: `${menuList.project.slug}-delivery-penjemputan`,
                    name: 'Delivery Penjemputan',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {
                        one: {
                            flag: `${menuList.project.slug}-nota`,
                            name: 'Nota',
                        },
                        two: {
                            flag: `${menuList.project.slug}-segera-menjemput`,
                            name: 'Segera Menjemput',
                        },
                        three: {
                            flag: `${menuList.project.slug}-sedang-menjemput`,
                            name: 'Sedang Menjemput',
                        },
                        four: {
                            flag: `${menuList.project.slug}-sudah-input-data`,
                            name: 'Sudah Input Data',
                        },
                        five: {
                            flag: `${menuList.project.slug}-sudah-serah-terima`,
                            name: 'Sudah Serah Terima',
                        },
                        six: {
                            flag: `${menuList.project.slug}-penjemputan-dibatalkan`,
                            name: 'Penjemputan Dibatalkan',
                        },
                    }
                },
                // four: {
                //     flag: `${menuList.project.slug}-delivery-pengantaran`,
                //     name: 'Delivery Pengantaran',
                //     icon: <SetIcon StateIcon={IconPoint} />,
                //     menu: menuList.project.slug,
                //     tabs: {
                //         one: {
                //             flag: `${menuList.project.slug}-nota`,
                //             name: 'Nota',
                //         },
                //         two: {
                //             flag: `${menuList.project.slug}-segera-mengantar`,
                //             name: 'Segera Mengantar',
                //         },
                //         three: {
                //             flag: `${menuList.project.slug}-sedang-mengantar`,
                //             name: 'Sedang Mengantar',
                //         },
                //         four: {
                //             flag: `${menuList.project.slug}-sudah-serah-terima`,
                //             name: 'Sudah Serah Terima',
                //         },
                //         five: {
                //             flag: `${menuList.project.slug}-pengantaran-dibatalkan`,
                //             name: 'Pengantaran Dibatalkan',
                //         },
                //     }
                // },
            }
        }
    },
    account: {
        ...menuList.account,
        ...{
            subMenu: {
                one: {
                    flag: `${menuList.account.slug}-account`,
                    name: 'Account',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.account.slug,
                    tabs: {
                        one: {
                            flag: `${menuList.account.slug}-tab-reset-email`,
                            name: 'Reset Email',
                        },
                        two: {
                            flag: `${menuList.account.slug}-tab-reset-username-password`,
                            name: 'Reset Username dan Password',
                        },
                    }
                }
            }
        }
    },
    // stockAdjustment: {
    //     ...menuList.stockAdjustment,
    //     ...{
    //         subMenu: {
    //             one: {
    //                 flag: `${menuList.stockAdjustment.slug}-penyesuaian-stok`,
    //                 name: 'Penyesuaian Stok',
    //                 icon: <SetIcon StateIcon={IconPoint} />,
    //                 menu: menuList.stockAdjustment.slug,
    //                 tabs: {}
    //             },
    //         }
    //     }
    // },
    // dev: {
    //     ...menuList.dev,
    //     ...{
    //         subMenu: {
    //             one: {
    //                 flag: 'custom-components',
    //                 name: 'Custom Components',
    //                 icon: <SetIcon StateIcon={IconPoint} />,
    //                 menu: menuList.dev.slug,
    //                 tabs: {}
    //             },
    //             two: {
    //                 flag: 'insert-database',
    //                 name: 'Insert Database',
    //                 icon: <SetIcon StateIcon={IconPoint} />,
    //                 menu: menuList.dev.slug,
    //                 tabs: {}
    //             },
    //             three: {
    //                 flag: 'jwt',
    //                 name: 'JWT',
    //                 icon: <SetIcon StateIcon={IconPoint} />,
    //                 menu: menuList.dev.slug,
    //                 tabs: {}
    //             },
    //             four: {
    //                 flag: 'alur',
    //                 name: 'Alur',
    //                 icon: <SetIcon StateIcon={IconPoint} />,
    //                 menu: menuList.dev.slug,
    //                 tabs: {
    //                     one: {
    //                         flag: `${menuList.dev.slug}-tab-ketentuan-garansi`,
    //                         name: 'Garansi',
    //                     },
    //                 }
    //             },
    //         }
    //     }
    // },
}

export const menuListTeknisiKoordinator = {
    master: {
        ...menuList.master,
        ...{
            subMenu: {
                brgKtgr: {
                    flag: `${menuList.master.slug}-barang-kategori`,
                    name: 'Kategori Barang',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {}
                },
                formCekBrg: {
                    flag: `${menuList.master.slug}-form-cek-barang`,
                    name: 'Form Cek Barang',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {}
                },
            }
        }
    },
    project: {
        ...menuList.project,
        ...{
            subMenu: {
                zero: {
                    flag: `${menuList.project.slug}-home`,
                    name: 'Home',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {
                        one: {
                            flag: tabHomePengecekanIndex,
                            name: 'Pengecekan',
                        },
                    }
                },
                one: {
                    flag: subMenuProject, /* utils ini harus sama penamaannya utk setiap user karena ada modul (direct delivery penjemputan pemuatan nota ke step project nota pakai utils ini) */
                    name: 'Proses',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {
                        two: {
                            flag: tabProject.antrian,
                            name: 'Antrian',
                        },
                        three: {
                            flag: tabProject.pengerjaan,
                            name: 'Pengerjaan',
                        },
                        four: {
                            flag: tabProject.qc,
                            name: 'QC',
                        },
                        five: {
                            flag: tabProject.selesai,
                            name: 'Selesai',
                        },
                        six: {
                            flag: tabProject.sudahDiambil,
                            name: 'Sudah Diambil',
                        },
                        seven: {
                            flag: tabProject.dibatalkan,
                            name: 'Dibatalkan',
                        }
                    }
                },
                serialNumberChecker: {
                    flag: `${menuList.project.slug}-cek-serial-number`,
                    name: 'Cek Serial Number',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {}
                },
            }
        }
    },
    account: {
        ...menuList.account,
        ...{
            subMenu: {
                one: {
                    flag: `${menuList.account.slug}-account`,
                    name: 'Account',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.account.slug,
                    tabs: {
                        one: {
                            flag: `${menuList.account.slug}-tab-reset-email`,
                            name: 'Reset Email',
                        },
                        two: {
                            flag: `${menuList.account.slug}-tab-reset-username-password`,
                            name: 'Reset Username dan Password',
                        },
                    }
                }
            }
        }
    },
}

export const menuListTeknisiStaf = {
    master: {
        ...menuList.master,
        ...{
            subMenu: {
                brgKtgr: {
                    flag: `${menuList.master.slug}-barang-kategori`,
                    name: 'Kategori Barang',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {}
                },
                formCekBrg: {
                    flag: `${menuList.master.slug}-form-cek-barang`,
                    name: 'Form Cek Barang',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {}
                },
            }
        }
    },
    project: {
        ...menuList.project,
        ...{
            subMenu: {
                zero: {
                    flag: `${menuList.project.slug}-home`,
                    name: 'Home',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {
                        one: {
                            flag: tabHomePengecekanIndex,
                            name: 'Pengecekan',
                        },
                    }
                },
                one: {
                    flag: subMenuProject, /* utils ini harus sama penamaannya utk setiap user karena ada modul (direct delivery penjemputan pemuatan nota ke step project nota pakai utils ini) */
                    name: 'Proses',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {
                        two: {
                            flag: tabProject.antrian,
                            name: 'Antrian',
                        },
                        three: {
                            flag: tabProject.pengerjaan,
                            name: 'Pengerjaan',
                        },
                        four: {
                            flag: tabProject.qc,
                            name: 'QC',
                        },
                        five: {
                            flag: tabProject.selesai,
                            name: 'Selesai',
                        },
                        six: {
                            flag: tabProject.sudahDiambil,
                            name: 'Sudah Diambil',
                        },
                        seven: {
                            flag: tabProject.dibatalkan,
                            name: 'Dibatalkan',
                        }
                    }
                },
                serialNumberChecker: {
                    flag: `${menuList.project.slug}-cek-serial-number`,
                    name: 'Cek Serial Number',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {}
                },
            }
        }
    },
    account: {
        ...menuList.account,
        ...{
            subMenu: {
                one: {
                    flag: `${menuList.account.slug}-account`,
                    name: 'Account',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.account.slug,
                    tabs: {
                        one: {
                            flag: `${menuList.account.slug}-tab-reset-email`,
                            name: 'Reset Email',
                        },
                        two: {
                            flag: `${menuList.account.slug}-tab-reset-username-password`,
                            name: 'Reset Username dan Password',
                        },
                    }
                }
            }
        }
    },
}

export const menuListAdminStaf = {
    master: {
        ...menuList.master,
        ...{
            subMenu: {
                two: {
                    flag: `${menuList.master.slug}-customer`,
                    name: 'Customer',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {}
                },
                customerGroup: {
                    flag: `${menuList.master.slug}-customer-group`,
                    name: 'Customer Group',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {}
                },
                brgKtgr: {
                    flag: `${menuList.master.slug}-barang-kategori`,
                    name: 'Kategori Barang',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {}
                },
                formCekBrg: {
                    flag: `${menuList.master.slug}-form-cek-barang`,
                    name: 'Form Cek Barang',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {}
                },
                stock: {
                    flag: `${menuList.master.slug}-stock`,
                    name: 'Stok Item',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {
                        one: {
                            flag: `${menuList.master.slug}-tab-stock-item`,
                            name: 'Stok Item',
                        },
                        two: {
                            flag: `${menuList.master.slug}-tab-stock-category`,
                            name: 'Stok Kategori',
                        },
                        three: {
                            flag: `${menuList.master.slug}-tab-stock-category-sub`,
                            name: 'Stok Sub Kategori',
                        },
                        four: {
                            flag: `${menuList.master.slug}-tab-stock-damaged`,
                            name: 'Stok Rusak',
                        },
                    }
                },
                supplier: {
                    flag: `${menuList.master.slug}-supplier`,
                    name: 'Supplier',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {}
                },
                discount: {
                    flag: `${menuList.master.slug}-discount`,
                    name: 'Discount Voucher',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.master.slug,
                    tabs: {
                        one: {
                            flag: `${menuList.master.slug}-tab-discount-voucher`,
                            name: 'Diskon Voucher',
                        },
                        two: {
                            flag: `${menuList.master.slug}-tab-discount-khusus`,
                            name: 'Diskon Khusus',
                        },
                    }
                },
            }
        }
    },
    project: {
        ...menuList.project,
        ...{
            subMenu: {
                one: {
                    flag: subMenuProject, /* utils ini harus sama penamaannya utk setiap user karena ada modul (direct delivery penjemputan pemuatan nota ke step project nota pakai utils ini) */
                    name: 'Proses',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {
                        one: {
                            flag: tabProject.nota,
                            name: 'Nota',
                        },
                        two: {
                            flag: tabProject.antrian,
                            name: 'Antrian',
                        },
                        three: {
                            flag: tabProject.pengerjaan,
                            name: 'Pengerjaan',
                        },
                        four: {
                            flag: tabProject.qc,
                            name: 'QC',
                        },
                        five: {
                            flag: tabProject.selesai,
                            name: 'Selesai',
                        },
                        six: {
                            flag: tabProject.sudahDiambil,
                            name: 'Sudah Diambil',
                        },
                        seven: {
                            flag: tabProject.dibatalkan,
                            name: 'Dibatalkan',
                        }
                    }
                },
                two: {
                    flag: `${menuList.project.slug}-garansi`,
                    name: 'Klaim Garansi',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {
                        one: {
                            flag: `${menuList.project.slug}-tab-pengajuan-garansi`,
                            name: utils.statusItemGaransi.pengajuan_klaim_garansi.caption,
                        },
                        two: {
                            flag: `${menuList.project.slug}-tab-kirim-supplier-garansi`,
                            name: utils.statusItemGaransi.sudah_dikirim_ke_supplier.caption,
                        },
                        three: {
                            flag: `${menuList.project.slug}-tab-history-garansi`,
                            name: 'History Klaim Garansi',
                        },
                    }
                },
                serialNumberChecker: {
                    flag: `${menuList.project.slug}-cek-serial-number`,
                    name: 'Cek Serial Number',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {}
                },
                three: {
                    flag: `${menuList.project.slug}-delivery-penjemputan`,
                    name: 'Delivery Penjemputan',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.project.slug,
                    tabs: {
                        one: {
                            flag: `${menuList.project.slug}-nota`,
                            name: 'Nota',
                        },
                        two: {
                            flag: `${menuList.project.slug}-segera-menjemput`,
                            name: 'Segera Menjemput',
                        },
                        three: {
                            flag: `${menuList.project.slug}-sedang-menjemput`,
                            name: 'Sedang Menjemput',
                        },
                        four: {
                            flag: `${menuList.project.slug}-sudah-input-data`,
                            name: 'Sudah Input Data',
                        },
                        five: {
                            flag: `${menuList.project.slug}-sudah-serah-terima`,
                            name: 'Sudah Serah Terima',
                        },
                        six: {
                            flag: `${menuList.project.slug}-penjemputan-dibatalkan`,
                            name: 'Penjemputan Dibatalkan',
                        },
                    }
                },
                // four: {
                //     flag: `${menuList.project.slug}-delivery-pengantaran`,
                //     name: 'Delivery Pengantaran',
                //     icon: <SetIcon StateIcon={IconPoint} />,
                //     menu: menuList.project.slug,
                //     tabs: {
                //         one: {
                //             flag: `${menuList.project.slug}-nota`,
                //             name: 'Nota',
                //         },
                //         two: {
                //             flag: `${menuList.project.slug}-segera-mengantar`,
                //             name: 'Segera Mengantar',
                //         },
                //         three: {
                //             flag: `${menuList.project.slug}-sedang-mengantar`,
                //             name: 'Sedang Mengantar',
                //         },
                //         four: {
                //             flag: `${menuList.project.slug}-sudah-serah-terima`,
                //             name: 'Sudah Serah Terima',
                //         },
                //         five: {
                //             flag: `${menuList.project.slug}-pengantaran-dibatalkan`,
                //             name: 'Pengantaran Dibatalkan',
                //         },
                //     }
                // },
            }
        }
    },
    account: {
        ...menuList.account,
        ...{
            subMenu: {
                one: {
                    flag: `${menuList.account.slug}-account`,
                    name: 'Account',
                    icon: <SetIcon StateIcon={IconPoint} />,
                    menu: menuList.account.slug,
                    tabs: {
                        one: {
                            flag: `${menuList.account.slug}-tab-reset-email`,
                            name: 'Reset Email',
                        },
                        two: {
                            flag: `${menuList.account.slug}-tab-reset-username-password`,
                            name: 'Reset Username dan Password',
                        },
                    }
                }
            }
        }
    },
}